<script lang="ts" setup>
import { useElementClick } from '@/composables/tracks'
import { useCallApp } from '@/composables/useBannerShow'
import { useI18n } from '@/composables/useI18n'

const props = defineProps<{
  position: 'fixed' | 'block'
  id?: string
  index?: number
  from: 'home' | 'book' | 'chapter'
}>()
const { callApp } = useCallApp()
const { elementClick } = useElementClick()
const { t } = useI18n()

function downloadApp() {
  if (props.from === 'home')
    elementClick('download_app')

  else if (props.from === 'book')
    elementClick(`content:${props.id}:download`)

  else if (props.from === 'chapter')
    elementClick('reading_download')

  callApp(props.id, props.index)
}
</script>

<template>
  <div
    class="
      download-app-banner
      h-60px
      flex
      items-center
      justify-between
      px-4
    "
    :class="{
      'my-3.75': props.position === 'block',
      'my-0px': props.position === 'fixed',
      'border-rd-8px': props.position === 'block',
      'border-rd-0px': props.position === 'fixed',
    }"
  >
    <div class="text-n-primary! font-medium">
      {{ t('DownloadApp') }}
    </div>

    <div class="w-110px line-clamp-1 h-28px border-rd-16px text-12px text-n-bg-pure! btn-solid line-height-28px text-center" @click="downloadApp">
      {{ t('DownloadAppNow') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.download-app-banner {
  background-image: url('@/assets/banner.webp');
  background-size: 100% 100%;
  z-index: 100;
}
</style>
